import { createApi } from "@reduxjs/toolkit/query/react";
import customFetchBase from "./customFetchBaseQuery";

// Single RTK Query API for the whole app. Endpoints are injected from
// auth/authApi.js and user/userApi.js; reads are queries (cached, tagged) and
// writes are mutations that invalidate the tags they affect.
export const api = createApi({
  reducerPath: "api",
  baseQuery: customFetchBase,
  tagTypes: [
    "Admin",
    "Customer",
    "Shopper",
    "Vendor",
    "Area",
    "Category",
    "Country",
    "Market",
    "Support",
    "Uom",
    "PriceByMarket",
    "Product",
    "Order",
    "Transaction",
    "Voucher",
    "Bank",
    "Stats",
  ],
  endpoints: () => ({}),
});

// Tags for a list response: one per item plus a LIST tag, so editing an item
// refreshes the lists it appears in and creating/deleting refreshes every list.
export const listTags = (type) => (result) =>
  [{ type, id: "LIST" }, ...(Array.isArray(result?.data) ? result.data.map((item) => ({ type, id: item?.id || item?._id })) : [])];

export const itemTags = (type) => (result, error, id) => [{ type, id }];

// For mutations called with ({ id, data }).
export const invalidateItem =
  (...types) =>
  (result, error, arg) =>
    types.flatMap((type) => [
      { type, id: "LIST" },
      { type, id: arg?.id ?? arg },
    ]);

export const invalidateList =
  (...types) =>
  () =>
    types.map((type) => ({ type, id: "LIST" }));
